import axios from 'axios'
import { CommonPersonnelResponse } from '@/api/services/common/personnel/common-personnel.dto'
import { CommonJobCodeEnum } from '@/api/services/common/job/common-job.dto'
import { CommonResponsibilityCodeEnum } from '@/api/services/common/responsibility/common-responsibility.dto'
import { EntityComparatorUtils } from '@/shared/util/entity-comparator-utils'
import { Nullable } from '@/shared/types/app.types'

class PersonnelService {
    async getPersonnel(labId: number, job: Nullable<CommonJobCodeEnum>): Promise<CommonPersonnelResponse[]> {
        const params = {
            jobEnum: job
        }
        const response = await axios.get(`/laboratories/${labId}/personnel/index`, { params })
        return response.data
    }

    async getPersonnelByLaboratoryAndResponsibility(labId: number, responsibility: CommonResponsibilityCodeEnum): Promise<CommonPersonnelResponse[]> {
        const params = {
            responsibilities: responsibility
        }
        const response = await axios.get(`/laboratories/${labId}/personnel/indexByResponsibilities`, { params })
        return response.data.sort(EntityComparatorUtils.comparePersonsByName)
    }

    async findAllDistinctByResponsibilities(responsibility: CommonResponsibilityCodeEnum): Promise<CommonPersonnelResponse[]> {
        const params = {
            responsibilities: responsibility
        }
        const response = await axios.get(`/personnel/findAllByResponsibilities`, { params })
        return response.data
    }

    async getActivePersonnelByLaboratoriesOfCase(laboratoryId: number, caseId: number): Promise<CommonPersonnelResponse[]> {
        const params = {
            caseId: caseId,
            laboratoryId: laboratoryId
        }
        const response = await axios.get(`/personnel/byLaboratoriesOfCase`, { params })
        return response.data
    }
}

export const personnelService = new PersonnelService()
